import Icon from 'veui/components/Icon'

Icon.register({
  'arrow-to-top': {
    paths: [
      {
        d: 'M26.5 12.4V46a2 2 0 11-4 0V12.4L6.31 26.5a2 2 0 11-2.62-3l19.5-17a2 2 0 012.62 0l19.5 17a2 2 0 11-2.62 3L26.5 12.4zM6 5a2 2 0 110-4h37a2 2 0 110 4H6z'
      }
    ],
    width: '48',
    height: '48'
  }
})
